import React, { useState, useEffect } from "react";
import CurrencyFormat from "react-currency-format";
import RequestHandler from "util/RequestHandler";
import { Col, Row, Table, Spin, Empty } from "antd";
import DigitalKobi from "../HomeComponent/DigitalKobi/DigitalKobi";
import Widgets from "../HomeCards/Card";
import Widget from "components/Widget/index";
import { useMediaQuery } from 'react-responsive'

const DigitalKobiHome = (props) => {

    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1500px)' })

    const [isDigitHomePage, setIsDigitHomePage] = useState(false);
    const [eInvoiceOutTotalValue, setEInvoiceOutTotalValue] = useState(0);
    const [eInvoiceOutCountValue, setEInvoiceOutCountValue] = useState(0);
    const [eInvoiceInTotalValue, setEInvoiceInTotalValue] = useState(0);
    const [eInvoiceInCountValue, setEInvoiceInCountValue] = useState(0);
    const [eArchiveTotalValue, setEArchiveTotalValue] = useState(0);
    const [eArchiveCountValue, setEArchiveCountValue] = useState(0);
    const [outMonthlyTotalValue, setOutMonthlyTotalValue] = useState(0);
    const [inMonthlyTotalValue, setInMonthlyTotalValue] = useState(0);
    const [eInvoiceFirmList, setEInvoiceFirmValue] = useState([]);
    const [eArchiveFirmList, setArchiveFirmValue] = useState([]);

    const [loading, setLoading] = useState(true);
    const [permissions, setPermissions] = useState({
        loading: true,
        modules: [],
        isAdmin: false,
        defaultModuleId: null,
    });

    useEffect(() => {
        if (!props.permissions) {
            getUserPermissions();
        } else {
            setPermissions(props.permissions);
        }
    }, [props.permissions]);
    const getUserPermissions = () => {
        setPermissions({
            ...permissions,
            loading: false,
        });
        RequestHandler.get("/User/MenuPermissions").then((response) => {
            setPermissions({
                ...response,
                loading: false,
            });
            localStorage.setItem("defaultModuleId", response.defaultModuleId);
        });
    };

    useEffect(() => {
        if (permissions.loading) {
            return;
        }
        setTimeout(() => {
            setLoading(false);
        }, 5000);

        RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then(
            (response) => {
                if (response.success) {
                    setIsDigitHomePage(response.data.isDigitHomePage);
                }
            }
        );
        RequestHandler.get(`/EInvoice/GetDigitalKobiIndexFirm`).then(
            (response) => {
                setEInvoiceFirmValue(response);
            }
        );
        RequestHandler.get(`/EArchive/GetDigitalKobiIndexFirm`).then(
            (response) => {
                setArchiveFirmValue(response);
            }
        );
        RequestHandler.get(`/EInvoice/DigitalKobiIndexHeader`).then(
            (response) => {
                setEInvoiceOutTotalValue(response.eInvoiceOutTotal)
                setEInvoiceOutCountValue(response.eInvoiceOutCount)
                setEInvoiceInTotalValue(response.eInvoiceInTotal)
                setEInvoiceInCountValue(response.eInvoiceInCount)
                setEArchiveTotalValue(response.eArchiveTotal)
                setEArchiveCountValue(response.eArchiveCount)
                setOutMonthlyTotalValue(response.outMonthlyTotal)
                setInMonthlyTotalValue(response.inMonthlyTotal)
            }
        );
    }, [permissions.loading]);

    const monthNames = ["OCAK", "ŞUBAT", "MART", "NİSAN", "MAYIS", "HAZİRAN", "TEMMUZ", "AĞUSTOS", "EYLÜL", "EKİM", "KASIM", "ARALIK"];
    const date = new Date();
    const columns = [
        {
            title: "Firma Adı",
            dataIndex: "firmName",
        },
        {
            title: "Fatura Adedi",
            dataIndex: "count",
        },
        {
            title: "Fatura Toplamı",
            dataIndex: "totalString",
            render: (text, row, index) => {
                {
                    return (
                        <div
                            style={{ width: 98, whiteSpace: "nowrap", textAlign: "right" }}
                        >
                            {row.total < 0 ? (
                                <div style={{ color: "red" }}>{text}</div>
                            ) : (
                                <div style={{ color: "green", whiteSpace: "nowrap" }}>
                                    {text}
                                </div>
                            )}
                        </div>
                    )
                }
            },
        }
    ];
    return (
        <>
            <Spin spinning={loading}>
                <Row style={{ marginLeft: 2 }}>
                    <Col span={24}>
                        <div class="ant-row">
                            <Widgets
                                icon="revenue-new"
                                currency={""}
                                title="Toplam Kesilen Fatura Tutarı"
                                warning={false}
                                totalBalance={
                                    !isDigitHomePage ? (
                                        <CurrencyFormat
                                            value={parseFloat(
                                                eInvoiceOutTotalValue.toString().split(".")[0]
                                            )}
                                            displayType={"text"}
                                            decimalSeparator={","}
                                            thousandSeparator={"."}
                                            suffix={" TL"}
                                        />
                                    ) : (
                                        <CurrencyFormat
                                            value={eInvoiceOutTotalValue}
                                            displayType={"text"}
                                            decimalSeparator={","}
                                            thousandSeparator={"."}
                                            suffix={" TL"}
                                        />
                                    )
                                }
                            />
                            <Widgets
                                icon="stats"
                                currency={""}
                                title="Toplam Kesilen Fatura Adedi"
                                warning={false}
                                totalBalance={eInvoiceOutCountValue}
                            />
                            <Widgets
                                icon="revenue-new"
                                currency={""}
                                title="Toplam Gelen Fatura Tutarı"
                                warning={false}
                                totalBalance={
                                    !isDigitHomePage ? (
                                        <CurrencyFormat
                                            value={parseFloat(
                                                eInvoiceInTotalValue.toString().split(".")[0]
                                            )}
                                            displayType={"text"}
                                            decimalSeparator={","}
                                            thousandSeparator={"."}
                                            suffix={" TL"}
                                        />
                                    ) : (
                                        <CurrencyFormat
                                            value={eInvoiceInTotalValue}
                                            displayType={"text"}
                                            decimalSeparator={","}
                                            thousandSeparator={"."}
                                            suffix={" TL"}
                                        />
                                    )
                                }
                            />
                            <Widgets
                                icon="stats"
                                currency={""}
                                title="Toplam Gelen Fatura Adedi"
                                warning={false}
                                totalBalance={eInvoiceInCountValue}
                            />
                            <Widgets
                                icon="revenue-new"
                                currency={""}
                                title="Toplam Kesilen E-Arşiv Tutarı"
                                warning={false}
                                totalBalance={
                                    !isDigitHomePage ? (
                                        <CurrencyFormat
                                            value={parseFloat(
                                                eArchiveTotalValue.toString().split(".")[0]
                                            )}
                                            displayType={"text"}
                                            decimalSeparator={","}
                                            thousandSeparator={"."}
                                            suffix={" TL"}
                                        />
                                    ) : (
                                        <CurrencyFormat
                                            value={eArchiveTotalValue}
                                            displayType={"text"}
                                            decimalSeparator={","}
                                            thousandSeparator={"."}
                                            suffix={" TL"}
                                        />
                                    )
                                }
                            />
                            <Widgets
                                icon="stats"
                                currency={""}
                                title="Toplam Kesilen E-Arşiv Adedi"
                                warning={false}
                                totalBalance={eArchiveCountValue}
                            />
                            <Widgets
                                icon="ArrowUp.svg"
                                color="green"
                                currency={""}
                                title={`${monthNames[date.getMonth()]} ayı kesilen`}
                                warning={true}
                                toolTipTitle={"Bu tutar, bulunan aya ait kesilmiş e-fatura ve e-arşiv fatura toplamını vermektedir."}
                                totalBalance={
                                    !isDigitHomePage ? (
                                        <CurrencyFormat
                                            value={parseFloat(
                                                outMonthlyTotalValue.toString().split(".")[0]
                                            )}
                                            displayType={"text"}
                                            decimalSeparator={","}
                                            thousandSeparator={"."}
                                            suffix={" TL"}
                                        />
                                    ) : (
                                        <CurrencyFormat
                                            value={outMonthlyTotalValue}
                                            displayType={"text"}
                                            decimalSeparator={","}
                                            thousandSeparator={"."}
                                            suffix={" TL"}
                                        />
                                    )
                                }
                            />
                            <Widgets
                                icon="ArrowDown.svg"
                                color="red"
                                warning={true}
                                toolTipTitle={"Bu tutar, bulunan aya ait kesilmiş fatura toplamını vermektedir."}
                                currency={""}
                                title={`${monthNames[date.getMonth()]} ayı gelen`}
                                totalBalance={
                                    !isDigitHomePage ? (
                                        <CurrencyFormat
                                            value={parseFloat(
                                                inMonthlyTotalValue.toString().split(".")[0]
                                            )}
                                            displayType={"text"}
                                            decimalSeparator={","}
                                            thousandSeparator={"."}
                                            suffix={" TL"}
                                        />
                                    ) : (
                                        <CurrencyFormat
                                            value={inMonthlyTotalValue}
                                            displayType={"text"}
                                            decimalSeparator={","}
                                            thousandSeparator={"."}
                                            suffix={" TL"}
                                        />
                                    )
                                }
                            />
                        </div>
                    </Col>
                    <Col span={12} style={{ marginTop: 20, marginBottom: 20 }}>
                        <DigitalKobi isDigitHomePage={isDigitHomePage} IsEInvoice={true} />
                    </Col>
                    <Col span={12} style={{ marginTop: 20, marginBottom: 20 }}>
                        <DigitalKobi isDigitHomePage={isDigitHomePage} IsEInvoice={false} />
                    </Col>
                    <Col span={12}>
                        <Widget
                            title={
                                <h2 className="gx-text-capitalize gx-mb-0">
                                    E-Fatura Cari Durumu</h2>
                            } styleName="gx-card-ticketlist"
                            extra={<h2 className="gx-mb-0 gx-pointer gx-d-none gx-d-sm-block">
                                <a href="/EinvoiceList" className="ak-jumbo-grey-text">Tüm Hesaplar{" "}
                                    <img src={require(`assets/images/Icons/ChevronLeft.svg`)} alt="icon" style={{ width: 23, height: 23 }} /></a>
                            </h2>}>
                            <div className="gx-table-responsive">
                                <Table
                                    className="gx-table-no-bordered"
                                    locale={{
                                        emptyText: (
                                            <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description="Veri Yok"
                                            />
                                        ),
                                    }}
                                    rowKey="firmName"
                                    columns={columns}
                                    dataSource={eInvoiceFirmList}
                                    pagination={false}
                                    size="small"
                                />
                            </div>

                        </Widget>
                    </Col>
                    <Col span={12}>
                        <Widget
                            title={
                                <h2 className="gx-text-capitalize gx-mb-0">
                                    E-Arşiv Cari Durumu</h2>
                            } styleName="gx-card-ticketlist"
                            extra={<h2 className="gx-mb-0 gx-pointer gx-d-none gx-d-sm-block">
                                <a href="/EArchiveList" className="ak-jumbo-grey-text">Tümü{" "}
                                    <img src={require(`assets/images/Icons/ChevronLeft.svg`)} alt="icon" style={{ width: 23, height: 23 }} /></a>
                            </h2>
                            }>
                            <div className="gx-table-responsive">
                                <Table
                                    className="gx-table-no-bordered"
                                    locale={{
                                        emptyText: (
                                            <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description="Veri Yok"
                                            />
                                        ),
                                    }}
                                    rowKey="firmName"
                                    columns={columns}
                                    dataSource={eArchiveFirmList}
                                    pagination={false}
                                    size="small"
                                />
                            </div>

                        </Widget>
                    </Col>
                </Row>
            </Spin>
        </>
    );
}
export default DigitalKobiHome;